const NotFound = () => {
  return (
    <div className="alert alert-danger">
      <h2>Page introuvable</h2>
      <div>La page demandée est introuvable.</div>
    </div>
  )
}
export default NotFound
